import { Component, OnInit } from '@angular/core';
import { FileUploader, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
import { environment } from '../../environments/environment';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-cargue-masivo',
  templateUrl: './cargue-masivo.component.html',
  styleUrls: ['./cargue-masivo.component.css']
})
export class CargueMasivoComponent implements OnInit {

  uploader: FileUploader;
  constructor() { }

  ngOnInit() {
    this.uploader = new FileUploader({ url: environment.administradorIpEndPoint + 'cargar/archivoVlansNubes', removeAfterUpload: true, autoUpload: true });
    this.uploader.onErrorItem = (item, response, status, headers) => this.onErrorItem(item, response, status, headers);
    this.uploader.onSuccessItem = (item, response, status, headers) => this.onSuccessItem(item, response, status, headers);
  }


  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let data = JSON.parse(response); //success server response

    if (data.estado) {
      swal("Se proceso correctamente el archivo", "", "success").then(function () {
        // Redirect the user
        window.location.href = "/#/solicitar-ip";
      });

    } else {
      swal("Se presento un error", data.mensaje, "error").then(function () {
        // Redirect the user
        window.location.reload();
      })

    }


  }

  onErrorItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    let error = JSON.parse(response); //error server response
    swal("Se presento un error", "", "error").then(function () {
      // Redirect the user
      window.location.reload();
    })
  }

  onChange(event) {
    swal({
      title: "Procesando el archivo",
      text: "espere un momento",
      icon: "warning",
      dangerMode: true,
      allowEscapeKey: false,
      allowOutsideClick: false,
      buttons: {
      }
    } as any)
  }
  downloadFile() {
    let link = document.createElement("a");
    link.download = "FormatoCargueMasivoVlan";
    link.href = "../../assets/documents/FormatoCargueMasivoVlans.xlsx";
    link.click();
  }
}







// WEBPACK FOOTER //
// ./src/app/cargue-masivo/cargue-masivo.component.ts